export const polstMoveMethod = {
  moveUpCondition: item => {
    return false;
  },
  moveDownCondition: item => {
    return false;
  },
  moveUp(item, accessories, index) {
    return false;
  },
  moveDown(item, accessories, index) {
    return false;
  },
  switchAltitude: (prevAltitude, item, index) => {
    const { position } = item;
    const [, max] = position;
    return max;
  },
};

export const polstCalcIsSpaceEnough = (maxSpace, item, list) => {
  const { position } = item;

  const [min, max] = position;
  const prevItem = list[maxSpace.indexElement];

  if (prevItem) {
    if (list.length === 1 && prevItem.slug.includes('_dr_')) {
      return {
        ...maxSpace,
        position: prevItem.altitude === min ? max : min,
      };
    }
  }

  return maxSpace;
};
